import { IAccountBalanceLineItem } from "@app/shared/shared.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const accountBalanceAdapter: EntityAdapter<IAccountBalanceLineItem> = createEntityAdapter<IAccountBalanceLineItem>({
	selectId: balance => balance.referenceNumber
});